import styled from '@emotion/styled'
import { FC } from 'react'
import * as React from 'react'

import { StyledModalWrapper } from './primitives'

export type SimpleModalProps = {
  children: React.ReactNode
  height?: React.CSSProperties['height']
  width?: React.CSSProperties['width']
}

export const ModalBackdrop = styled.div`
  bottom: 0;
  background-color: var(--ModalBackground);
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 1000;
  min-height: calc(max(100vh));
  min-width: calc(max(100vw));
  display: block;
  margin: auto;
  &.out {
    opacity: 0;
  }
`

export const ModalContainer = styled.div`
  overflow: auto;
  height: 100vh;
  width: 100vw;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
`

export const ModalBody = styled.div<SimpleModalProps>`
  background-color: var(--White);
  border-radius: 4px;
  box-shadow: 0 0 15px rgba(var(--Graphite), 0.2);
  width: ${({ width }) => width || '900px'};
  height: ${({ height }) => height || 'unset'};

  &:not(.modal-static) {
    margin: auto;
    margin-top: 100px;
  }

  &.out {
    opacity: 0;
  }
`

export const SimpleModal: FC<SimpleModalProps> = ({ children, height, width }) => (
  <StyledModalWrapper>
    <ModalBackdrop>
      <ModalContainer>
        <ModalBody height={height} width={width}>
          {children}
        </ModalBody>
      </ModalContainer>
    </ModalBackdrop>
  </StyledModalWrapper>
)
